import { useCallback } from 'react'

import { useObjects } from 'data/hooks/objects'
import { useWorkflowSchema } from 'data/hooks/workflows/workflows'
import { filterRecordDataFields } from 'features/workflows/common'
import { fieldToWorkflowExtraOptions } from 'features/workflows/fieldToWorkflowExtraOptions'
import { useStackerUsersObject } from 'features/workspace/stackerUserUtils'

import { getTriggerUserOutput } from './utils'

export function useActionButtonTriggerFinalSchema() {
    const { data: objects } = useObjects()
    const { data: schema } = useWorkflowSchema()
    const usersObject = useStackerUsersObject()

    return useCallback(
        (config: WorkflowTriggerConfig): WorkflowSchemaTriggerType | undefined => {
            const type = schema?.triggers.find((t) => t.id === config.trigger_type)
            const object = objects?.find((o) => o._sid === config.settings?.object_id)

            if (!type || !object) {
                return undefined
            }

            return {
                ...type,
                outputs: [
                    {
                        id: 'record_id',
                        name: `Record in ${object.name}`,
                        type: 'lookup',
                        extra_options: { link_target_object_id: object._sid },
                    },
                    getTriggerUserOutput(usersObject),
                    ...type.outputs.map((o) => {
                        if (o.id === 'record_data') {
                            const group = o as WorkflowSchemaStateItemGroup
                            return {
                                ...group,
                                items: group.items.concat(
                                    filterRecordDataFields(object?.fields).map((f) => ({
                                        id: f.api_name,
                                        name: f.label,
                                        type: f.type,
                                        extra_options: fieldToWorkflowExtraOptions(f),
                                    })) as WorkflowSchemaStateItem[]
                                ),
                            }
                        }
                        return o
                    }),
                ],
            }
        },
        [objects, schema?.triggers, usersObject]
    )
}
